module.exports = __webpack_public_path__ + "img/bottom_opening_facing.ad5b83e4.png";